import { useWindowSize } from 'react-use';
import { BREAKPOINT_MIN_WIDTH } from '~go/web/src/js/constants/bs5_constants';

// use bs5 breakpoints
const useBS5Breakpoints = ({ min = 0, max = undefined, breakpoint = undefined }: { min?: number, max?: number, breakpoint?: keyof typeof BREAKPOINT_MIN_WIDTH }) => {
  const { width } = useWindowSize();

  return breakpoint ? width >= BREAKPOINT_MIN_WIDTH[breakpoint] : width >= min && (max === undefined || width <= max);
};

export default useBS5Breakpoints;
